<template>
  <div class="form-group" :class="{ 'has-error': showError }">
    <div :class="{ 'col-md-4': !stacked }">
      <label class="control-label"
        >{{ label }} <span v-if="required">*</span></label
      >
      <p class="help-block" v-if="helper" v-text="helper"></p>
    </div>
    <div :class="{ 'col-md-8': !stacked }">
      <input
        type="file"
        v-on:change="updateValue($event.target.files[0])"
        class="form-control"
        :name="name"
        :id="id"
        :readonly="readonly"
      />
      <p class="text-danger" v-if="showError" v-text="errorMessage"></p>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    showError: Boolean,
    stacked: Boolean,
    required: Boolean,
    readonly: Boolean,
    id: String,
    errorMessage: String,
    helper: String
  },

  methods: {
    updateValue(value) {
      this.$emit('selected', {
        name: this.name,
        file: value
      });
    }
  }
};
</script>
